import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Blank as Layout } from '../components/layouts';

class ErrorPage extends Component {
  
  getEmOut() {
    const { user: { isPublisher, isAdvertiser }, dispatch, redirectTo } = this.props;
    
    let rPath = '/';
    if (redirectTo) {
      rPath = redirectTo;
    } else if (isPublisher) {
      rPath = '/publisher/home/websites';
    } else if (isAdvertiser) {
      rPath = '/advertiser/home/accounts';
    }
    
    dispatch(push(rPath));
  }

  render403() {
    return (
      <div className="middle-box text-center animated fadeIn">
        <h1>403</h1>
        <h3 className="font-bold">Forbidden</h3>
        <div className="error-desc">
          You don't have sufficient permissions to access this page.<br />
          Please contact us to setup permissions needed to access this page. <br />
          <button 
            className="btn btn-primary m-t" 
            onClick={this.getEmOut.bind(this)}
          >
            Get me out of here!
          </button>
        </div>
      </div>
    );
  }

  render404() {
    return (
      <div className="middle-box text-center animated fadeIn">
        <h1>404</h1>
        <h3 className="font-bold">Page Not Found</h3>
        <div className="error-desc">
          Sorry, but the page you are looking for doesn't exist or has been removed. 
          <br />
          <button 
            className="btn btn-primary m-t" 
            onClick={this.getEmOut.bind(this)}
          >
            Get me out of here!
          </button>
        </div>
      </div>
    );
  }

  render500() {
    return (
      <div className="middle-box text-center animated fadeIn">
        <h1>500</h1>
        <h3 className="font-bold">Internal Server Error</h3>
        <div className="error-desc">
          The server encountered something unexpected 
          that didn't allow it to complete the request. We apologize.<br />
          <button 
            className="btn btn-primary m-t" 
            onClick={this.getEmOut.bind(this)}
          >
            Get me out of here!
          </button>
        </div>
      </div>
    );
  }

  renderError() {
    const { errorCode, location: { pathname } } = this.props;
    switch (pathname) {
      case '/403':
        return this.render403();
      case '/404':
        return this.render404();
      case '/500':
        return this.render500();
      default:
        return errorCode ? this[`render${errorCode}`]() : this.render500();
    }
  }


  render() {
    const { noLayout, user: { isPublisher, isAdvertiser } } = this.props;
    return (
      noLayout ? this.renderError() :
        <Layout>
          <div className={isPublisher ? 'isPublisher' : (isAdvertiser ? 'isAdvertiser' : '')}>
            {this.renderError()}
          </div>     
        </Layout>
    );
  }
}


const mapStateToProps = (state) => {
  return { user: state.user.data };
};

export default connect(mapStateToProps)(ErrorPage);
